﻿<template>
    <form @submit.prevent="onLogin" autocomplete="off" class="flex w-screen align-items-center justify-content-center" style="height: calc(100vh - 3rem)">
        <div v-focustrap class="flex flex-column gap-2" style="width: 20rem;">
            <div class="flex text-4xl" v-t="'login.title'">
            </div>
            <!--(版本: v?.?.?.?)-->
            <div class="pb-3 font-bold text-red-500">{{ $t('login.version', { v: version }) }}</div>
            <div class="flex flex-column gap-2">
                <label v-t="'login.account'"></label>
                <IconField>
                    <InputIcon>
                        <i class="pi pi-user" />
                    </InputIcon>
                    <InputText v-model="account" :invalid="!account" class="" :placeholder="$t('login.account')" autofocus fluid></InputText>
                </IconField>
            </div>
            <div class="flex flex-column gap-2">
                <label v-t="'login.secret'"></label>
                <IconField>
                    <InputIcon>
                        <i class="pi pi-key" />
                    </InputIcon>
                    <InputText :invalid="!secret" v-model="secret" :feedback="false" class="" :placeholder="$t('login.secret')" type="password" autocomplete="new-password" spellcheck="false" fluid></InputText>
                </IconField>
            </div>
            <div class="flex justify-content-end" v-if="util$.pinia$.app.parameters.login.captcha.enabled">
                <Captcha ref="refVC" v-model="code" v-model:captchaKey="key"
                         v-model:codeLength="codeLength"
                         :enabled="util$.pinia$.app.parameters.login.captcha.enabled" />
            </div>
            <div class="flex justify-content-end">
                <Button type="submit" class="" :label="$t('login.login')" rounded :disabled="v$.$invalid" />
            </div>
        </div>
    </form>
    <!-- 載入中 -->
    <Loading :loading="loading">
    </Loading>
</template>

<script lang="ts">
    export default {
        name: module$.login,
        inheritAttrs: false
    }
</script>

<script setup lang="ts">
    import { handleError, ref } from 'vue';
    import { module$ } from '../enums'
    import { utilfcty$ } from '../utils/utility'
    import { useI18n } from 'vue-i18n';
    import { required } from "@vuelidate/validators";
    import { useVuelidate } from "@vuelidate/core";
    import Captcha from "../components/Captcha.vue"
    import Loading from "../components/Loading.vue"

    // ***************工具物件***************
    //util$物件
    const util$ = utilfcty$.vueUse();
    //locales/{locales}/login.json
    const { t } = useI18n(); // 取得翻譯函式 t
    //Captcha
    const refVC = ref();

    // ***************元件屬性|計算**********
    //package.json的版本號碼值
    const version = import.meta.env.PACKAGE_VERSION;
    const loading = ref(false);
    const account = ref('');
    const secret = ref('');
    const code = ref('');
    const key = ref('');
    const codeLength = ref(4);   // 初始值；由 Captcha 依後端回應更新（v-model:codeLength）
    const rules = {
        account: { required },
        secret: { required },
        code: {
            required: (value: string) => (!util$.pinia$.app.parameters.login.captcha.enabled || (value || '').length == codeLength.value)
        }
    }
    const v$ = useVuelidate(rules, { account, secret, code });

    // ***************函式/事件**************
    const onLogin = async () => {
        let model: any = {
            account: account.value,
            secret: secret.value
        };
        if (util$.pinia$.app.parameters.login.captcha.enabled) {
            //驗證碼資訊
            model.key = key.value;
            model.code = code.value;
        }

        const resetLoginInfo = () => {
            if (util$.pinia$.app.parameters.login.captcha.enabled) {
                refVC.value.loadCaptchaPicture(true);
            }
            //清除資料
            secret.value = '';
            code.value = '';
        };
        try {
            await util$.pinia$.app.loadFor(loading, async () => {
                await util$.helper$.sleep(1000);
                const result = await util$.pinia$.security.login(model);
                // 如果後端 API 沒報錯但登入失敗 (例如 result 為 false)
                if (!result) {
                    resetLoginInfo();
                }
            });
        } catch (error) {
            // 這裡會接到 Axios 攔截器 reject 出來的錯誤
            // Interceptor 已經跳了 Toast，我們在這裡只負責 UI 的狀態收尾
            util$.handleError(error, {
                context: 'Login',
                showMessage: true,
                onProcessed: resetLoginInfo  // 注意是冒號，且不要加括號 ()
            });
        }
    }

    // ***************元件監看***************

    // ***************元件鉤子***************

</script>